import React, { useEffect, useState } from 'react';

// redux
import useSelector from '../../../hooks/useTypedSelector';
import {
  getInstance,
  getCompId,
  getSiteUrl,
  getWixPublicData,
  isMobile,
} from '../../../services/wixServices';

import {
  selectLoadingStatus,
  selectAdUnitByCompId,
  getAdUnitByCompId,
} from '../../../store/adunits/adunitsSlice';
import useDispatch from '../../../hooks/useTypedDispatch';
import { DEFAULT_HEIGHT_PX, DEFAULT_WIDTH_PX } from '../../../constansts';
import { appendScript } from '../../../utils/appendScriptMeta';
import WIDGET_SIZE from '../../../enums/widgetSize';
import useBiLogger from '../../../hooks/useBiLogger';

declare global {
  interface Window {
    Wix: any;
  }
}
const LiveSiteWidgetContent = () => {
  const adUnitByCompId = useSelector(selectAdUnitByCompId);
  const loadingStatus = useSelector(selectLoadingStatus);
  const [responsiveDimention, setResponsiveDimention] = useState<{
    width: number;
    height: number;
  }>({ width: window.innerWidth, height: window.innerHeight });
  const compId = getCompId();
  const dispatch = useDispatch();
  const bi = useBiLogger();

  useEffect(() => {
    bi.report('live_site_ad_view');
    getWixPublicData(`${compId}`, 'COMPONENT').then((data: any) => {
      setResponsiveDimention(data[compId]);
    });
  }, []);

  useEffect(() => {
    const signedinstance = getInstance();
    if (loadingStatus === 'idle') {
      dispatch(getAdUnitByCompId({ instance: signedinstance, compId }));
    } else if (loadingStatus === 'succeeded') {
      if (!document.querySelector("[data-hook='adsbygoogle-script']")) {
        appendScript(adUnitByCompId?.data_ad_client, getSiteUrl());
      }
      // @ts-expect-error
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, [dispatch, loadingStatus, compId, adUnitByCompId]);


  const adClickHandler = () => {
    bi.report('live_site_ad_click');
  };
  if (loadingStatus === 'succeeded') {
    console.log('loadingStatus', window.innerHeight, window.innerWidth);
    return (
      <div tabIndex={0} role="button" onClick={adClickHandler}>
        <ins
          data-hook="adsbygoogle-ins"
          className="adsbygoogle"
          style={
            adUnitByCompId?.size === WIDGET_SIZE.fixed
              ? {
                  display: `inline-block`,
                  width: `${
                    isMobile()
                      ? DEFAULT_WIDTH_PX
                      : adUnitByCompId?.dimensions?.width
                  }px`,
                  height: `${
                    isMobile()
                      ? DEFAULT_HEIGHT_PX
                      : adUnitByCompId?.dimensions?.height
                  }px`,
                }
              : {
                  display: `inline-block`,
                  width: `${
                    isMobile() ? DEFAULT_WIDTH_PX : responsiveDimention.width
                  }px`,
                  height: `${
                    isMobile() ? DEFAULT_HEIGHT_PX : responsiveDimention.height
                  }px`,
                }
          }
          data-ad-client={`${adUnitByCompId?.data_ad_client}`}
          data-ad-slot={`${adUnitByCompId?.data_ad_slot}`}
        ></ins>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default LiveSiteWidgetContent;
